export function getTimeStr(startTime: string, currentTime: number) {
  const date = new Date(startTime).getTime() + currentTime * 1000;

  return new Intl.DateTimeFormat('en-US', {
    timeStyle: 'medium',
  }).format(date);
}

function getExpirationDateFromVideoPath(videoPath: string): number | null {
  const videoUrl = new URL(videoPath);
  const expirationParam = videoUrl.searchParams.get('Expires');

  if (!expirationParam) return null;

  return Number(expirationParam) * 1000;
}

export function getRemainingMSecBeforeExpiration(
  videoPath: string
): number | false {
  const expirationDate = getExpirationDateFromVideoPath(videoPath);

  if (!expirationDate) return false;

  return expirationDate - Date.now();
}

// Image-only alarms need refreshing too: the <img> stays on screen once
// loaded, but the presigned url behind Download expires like any other.
export function getMediaRefetchInterval(
  media: { videoPath?: string; imagePath?: string } | undefined,
  isAirgap: boolean
): number | false {
  const mediaPath = media?.videoPath ?? media?.imagePath;

  if (isAirgap || !mediaPath) return false;

  return getRemainingMSecBeforeExpiration(mediaPath);
}
